import React from "react";
import styled from "@emotion/styled";
import CircularProgressbar from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import StatTypes from "types/StatTypes";

import CommonUtils from "services/common/utils";
import StatsContainer from "components/StatsContainer";

const Label = styled.div`
  font-size: 10px;
  max-width: 120px;
  text-align: center;
`;

const CircleContainer = styled.div`
  width: 30%;
  margin-bottom: 6px;
`;

type Props = { data: StatTypes; numberOfSection: number };

function CircularStats({ data, numberOfSection }: Props): JSX.Element {
  if (!data?.toggle) return <></>;

  return (
    <StatsContainer
      disabled={data?.value === null || data?.value === undefined}
      headerColor={data?.headerColor}
      order={data?.type?.order}
      numberOfSection={numberOfSection}
    >
      <>
        <CircleContainer>
          {/* @ts-ignore */}
          <CircularProgressbar
            percentage={
              data?.value !== null && data?.value !== undefined
                ? // @ts-ignore
                  CommonUtils.formatNumber(data?.value)
                : "-"
            }
            styles={{
              path: {
                stroke: `rgba(244, 90, 92, 1)`,
              },
              trail: {
                stroke: `rgba(0, 90, 92, 1)`,
              },
              text: {
                fill: "black",
                fontSize: "21px",
                fontWeight: "bold",
              },
            }}
          />
        </CircleContainer>

        <Label>{(data?.label || "").toUpperCase()}</Label>
      </>
    </StatsContainer>
  );
}

export default CircularStats;
